module.exports = __webpack_public_path__ + "static/media/Philly.34658edb.png";